import styled from "styled-components";

import TableSection from "./TableSection/TableSection";

export const TableFooter = styled(TableSection)`
  margin-top: -30px;
  margin-bottom: 20px;
  margin-left: 120px;
`;
